import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { VideoRecordingDialogComponent } from 'src/app/modules/shared/dialogs/video-recording/video-recording-dialog.component';
import { SimulationParticipantService, SimulationService } from '../../services';
import { CreateOrUpdateSimulations, SimulationData } from '../../types';
import { MatTooltip } from '@angular/material/tooltip';
import { WsService } from 'src/app/modules/core/services/websocket.service';
import { SIMULATION_EVENT } from 'src/app/modules/shared/types';
import { ConfirmCloseDialogComponent } from 'src/app/modules/shared/dialogs/confirm-close-dialog';

@Component({
    selector: 'start-simulation-form-app',
    templateUrl: 'start-simulation-form.component.html',
    styleUrls: ['./start-simulation-form.component.scss'],
})
export class StartSimulationFormComponent implements OnInit {
    @ViewChild('matTooltipCopied') matTooltipCopied: MatTooltip;
    listUser: any;
    createOrUpdateModel: CreateOrUpdateSimulations = {
        simulationId: 0,
        actionType: '',
        detailsRequest: {
            name: '',
            startDate: 0,
            startTime: '',
            organizationId: '',
            simulationTypeId: '',
            roomNumber: '',
            participantLogAvailable: null,
        },
        settingsRequest: {
            loginCode: '',
            link: '',
            acceptJoinViaLink: false,
            allowJoinAfterSimulationStarts: false,
            startVideoRecording: false,
            invitePeople: [],
        },
    };
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: SimulationData,
        public dialog: MatDialog,
        public router: Router,
        public simulationService: SimulationService,
        public simulationParticipantService: SimulationParticipantService,
        private wsService: WsService,
    ) {
        if (this.data?.id) {
            this.getParticipantOnline()
        }
    }

    ngOnInit() {
        const link = this.data.link;
        if (link) {
            const regex = /\/(\d+)\?code=/;
            const match = link.match(regex);
            if (match) {
                const simulationId = match[1];
                this.wsService.connect(simulationId);
                this.wsService.messages.subscribe(result => {
                    try {
                        const decoded = JSON.parse(result);
                        if (decoded.event === SIMULATION_EVENT.STUDENT_JOIN || decoded.event === SIMULATION_EVENT.STUDENT_LEAVE) {
                            this.getParticipantOnline()
                        }
                    }
                    catch (e) { }
                });
            }
        }
    }

    onStartSimulationNow(): void {
        // this.openVideoRecordingForm();
        this.openVideoRecordingForm();
    }

    openVideoRecordingForm() {
        this.dialog.open(VideoRecordingDialogComponent, {
            data: this.createOrUpdateModel,
            width: '470px',
            height: '322px',
            position: {
                top: '78px',
            },
            panelClass: 'position-relative',
        });
    }

    copySimulationLink(): void {
        navigator.clipboard.writeText(`${this.createOrUpdateModel.settingsRequest.link}`);
        this.matTooltipCopied.disabled = false;
        this.matTooltipCopied.show();
        // inputElement.select();
        document.execCommand('copy');
        // inputElement.setSelectionRange(0, 0);
        // this.inputCopy.nativeElement.blur();
        setTimeout(() => {
            this.matTooltipCopied.disabled = true;
        }, 1000);
    }

    getParticipantOnline(): void {
        this.simulationParticipantService.getParticipantsOnline(this.data.id).subscribe(
            res => {
                this.createOrUpdateModel = {
                    simulationId: this.data.id,
                    actionType: 'start',
                    detailsRequest: {
                        name: this.data.name,
                        startDate: this.data.startDate,
                        startTime: this.data.startTime,
                        organizationId: this.data.organizationId,
                        simulationTypeId: this.data.simulationTypeId,
                        roomNumber: this.data.roomNumber,
                        participantLogAvailable: this.data.participantLogAvailable,
                    },
                    settingsRequest: {
                        loginCode: this.data.loginCode,
                        link: this.data.link,
                        acceptJoinViaLink: Boolean(this.data.acceptJoinViaLink),
                        invitePeople: res.data?.roomInfo?.participants?.map((item: any) => {
                            return {
                                name: item?.name,
                                avatar: item?.avatar ?? '',
                                email: item?.email ?? '',
                            };
                        }) ?? [],
                        allowJoinAfterSimulationStarts: Boolean(this.data.allowJoinAfterSimulationStarts),
                        startVideoRecording: Boolean(this.data.startVideoRecording),
                    },
                };
            },
            error => {
                console.log('get participant online ', error);
            },
        );
    }

    onCloseModal() {
        const confirmCloseDialog = this.dialog.open(ConfirmCloseDialogComponent, {
            width: '400px',
            height: '250px',
            position: {
                top: '78px',
            },
            panelClass: 'position-relative',
        });

        confirmCloseDialog.afterClosed().subscribe(data => {
            if (data == 'OK') {
                this.dialog.closeAll();
            }
        });
    }
}
